import { valibotResolver } from "@hookform/resolvers/valibot";
import { useForm } from "react-hook-form";

import { Button } from "common/components/ui/Button";
import FormField from "common/components/ui/FormField";
import TextArea from "common/components/ui/TextArea";
import useLeadNotes from "common/datahooks/useLeadNotes";
import { NoteSchema, type NoteSchemaType } from "common/schemas";

import type { KeyboardEvent } from "react";

export default function AddLeadNote({
  profileId,
  onSuccess,
  onDiscard,
}: {
  profileId: string;
  onSuccess?: () => void;
  onDiscard: () => void;
}) {
  const { addLeadNote, isAddingLeadNote } = useLeadNotes();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<NoteSchemaType>({
    resolver: valibotResolver(NoteSchema),
  });

  const onAddLeadNote = handleSubmit(onSubmit);

  function onSubmit({ text }: NoteSchemaType) {
    addLeadNote({ profileId, text }).then(() => {
      onSuccess?.();
      reset({ text: "" });
    });
  }

  function onKeyDown(e: KeyboardEvent) {
    if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) {
      onAddLeadNote();
    }
  }

  return (
    <>
      <FormField label="" htmlFor="" error={errors.text?.message}>
        <TextArea
          {...register("text")}
          aria-label="Lead notes"
          hasError={!!errors.text?.message}
          autoFocus
          minRows={4}
          maxRows={6}
          placeholder="Write something..."
          onKeyDown={onKeyDown}
          disabled={isAddingLeadNote}
        />
      </FormField>
      <div className="flex justify-end gap-x-2">
        <Button
          variant="outline-black"
          size="sm"
          disabled={isAddingLeadNote}
          onClick={onDiscard}
        >
          Discard
        </Button>
        <Button
          variant="secondary-purple"
          size="sm"
          isLoading={isAddingLeadNote}
          onClick={onAddLeadNote}
        >
          Save
        </Button>
      </div>
    </>
  );
}
